import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router-dom";

export function SentryService() {
    Sentry.init({
        dsn: 'https://ea18bd9745754cf64d179b9d87f3c915@sentry.webinar.ru/27',
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration(),
        ],
        environment: 'production',
        debug: !!localStorage.getItem('debug.sentry'),

        tracesSampleRate: 1.0, // Для первого тестирования установлено значение 1.0 (100%)
        tracePropagationTargets: [/^https?:\/\/.*\.comdi\.com\//],

        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}
